
import * as ipxRuntime$ARcsF7FXgJ from '/Users/gabrielfritsch/projetos/sorrifacil-site/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {}
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$ARcsF7FXgJ, defaults: undefined }
}
        